/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { exists, mapValues } from '../runtime';
// @ts-ignore
import type { OrderIncompleteDeliveryReason } from './OrderIncompleteDeliveryReason';
// @ts-ignore
import {
// @ts-ignore
    OrderIncompleteDeliveryReasonFromJSON,
// @ts-ignore
    OrderIncompleteDeliveryReasonFromJSONTyped,
// @ts-ignore
    OrderIncompleteDeliveryReasonToJSON,
} from './OrderIncompleteDeliveryReason';

/**
 * 
 * @export
 * @interface OrderIncompleteDelivery
 */
export interface OrderIncompleteDelivery {
    /**
     * 
     * @type {string}
     * @memberof OrderIncompleteDelivery
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof OrderIncompleteDelivery
     */
    orderId: string;
    /**
     * 
     * @type {OrderIncompleteDeliveryReason}
     * @memberof OrderIncompleteDelivery
     */
    reason: OrderIncompleteDeliveryReason;
    /**
     * 
     * @type {string}
     * @memberof OrderIncompleteDelivery
     */
    comment: string;
    /**
     * 
     * @type {Date}
     * @memberof OrderIncompleteDelivery
     */
    reportedAt: Date;
    /**
     * 
     * @type {boolean}
     * @memberof OrderIncompleteDelivery
     */
    resolved: boolean;
    /**
     * 
     * @type {Date}
     * @memberof OrderIncompleteDelivery
     */
    resolvedAt?: Date | null;
}

/**
 * Check if a given object implements the OrderIncompleteDelivery interface.
 */
// @ts-ignore
export function instanceOfOrderIncompleteDelivery(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "orderId" in value;
    isInstance = isInstance && "reason" in value;
    isInstance = isInstance && "comment" in value;
    isInstance = isInstance && "reportedAt" in value;
    isInstance = isInstance && "resolved" in value;

    return isInstance;
}

// @ts-ignore
export function OrderIncompleteDeliveryFromJSON(json: any): OrderIncompleteDelivery {
    return OrderIncompleteDeliveryFromJSONTyped(json, false);
}

// @ts-ignore
export function OrderIncompleteDeliveryFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderIncompleteDelivery {
// @ts-ignore
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'orderId': json['order_id'],
        'reason': OrderIncompleteDeliveryReasonFromJSON(json['reason']),
        'comment': json['comment'],
        'reportedAt': (new Date(json['reported_at'])),
        'resolved': json['resolved'],
        'resolvedAt': !exists(json, 'resolved_at') ? undefined : (json['resolved_at'] === null ? null : new Date(json['resolved_at'])),
    };
}

// @ts-ignore
export function OrderIncompleteDeliveryToJSON(value?: OrderIncompleteDelivery | null): any {
// @ts-ignore
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'order_id': value.orderId,
        'reason': OrderIncompleteDeliveryReasonToJSON(value.reason),
        'comment': value.comment,
        'reported_at': (value.reportedAt.toISOString()),
        'resolved': value.resolved,
        'resolved_at': value.resolvedAt === undefined ? undefined : (value.resolvedAt === null ? null : value.resolvedAt.toISOString()),
    };
}

